const handleMarquee = function () {
  const marquee = document.querySelectorAll(".marquee");
  let speed = 1.2;
  marquee.forEach((item) => {
    const content = item.querySelector("span");
    const elWidth = content.offsetWidth;
    let progress = 1;
    function loop() {
      progress = progress - speed;
      if (progress <= elWidth * -1) {
        progress = 0;
      }
      item.style.transform = "translateX(" + progress + "px)";
      window.requestAnimationFrame(loop);
    }
    const quantity = Math.round(window.innerWidth / elWidth);
    for (let i = 0; i < quantity + 3; i++) {
      let clone = content.cloneNode(true);
      item.appendChild(clone);
    }
    loop();
  });
};


function handleMarquee1(el, speed = .25) {
  const parentSelector = el;
  const clone = parentSelector.innerHTML;
  const firstElement = parentSelector.children[0];
  let i = 0;

  parentSelector.insertAdjacentHTML('beforeend', clone);
  parentSelector.insertAdjacentHTML('beforeend', clone);

  setInterval(function () {
    firstElement.style.marginLeft = `-${i}px`;
    if (i > firstElement.clientWidth) {
      i = 0;
    }
    i = i + speed;
  }, 0);
}


export default handleMarquee;
export { handleMarquee1 };